// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalItems_modal__0BUIf"};